var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTask = function SvgTask(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M15.333 4.667 10.667 8l4.666 3.333V4.667ZM.667 4.333a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v7.334a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1V4.333Z",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgTask as ReactComponent };
export default "data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M15.3334 4.66663L10.6667 7.99996L15.3334 11.3333V4.66663Z' stroke='inherit' stroke-linecap='round' stroke-linejoin='round'/%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M0.666748 4.33337C0.666748 3.78109 1.11446 3.33337 1.66675 3.33337H9.66675C10.219 3.33337 10.6667 3.78109 10.6667 4.33337V11.6667C10.6667 12.219 10.219 12.6667 9.66675 12.6667H1.66675C1.11446 12.6667 0.666748 12.219 0.666748 11.6667V4.33337Z' stroke='inherit' stroke-linecap='round' stroke-linejoin='round'/%3E %3C/svg%3E";